import React, { useState } from 'react';
import { Modal, Button, message, Space } from 'antd';
import { useDispatch } from 'react-redux';
// import { uploadVolatilities } from 'state'; // adjust import based on your project structure

type Props = {
  hide: () => void;
};

const UploadVolsModal: React.FC<Props> = ({ hide }) => {
  const dispatch = useDispatch();
  const [file, setFile] = useState<File | null>(null);
  const [uploading, setUploading] = useState(false);

  // Handle file selection from the user's computer
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setFile(e.target.files[0]);
    }
  };

  // When user clicks Upload, create FormData and dispatch the upload action.
  const handleUpload = async () => {
    if (!file) {
      message.error('Please select a file to upload.');
      return;
    }
    const formData = new FormData();
    // Append file with a key. (Backend expects the CSV file in the request payload)
    formData.append('file', file, file.name);

    setUploading(true);
    try {
      // Dispatch the action with the formData payload.
      // dispatch(uploadVolatilities({ data: formData }));
      message.success('File uploaded successfully.');
      hide();
    } catch (error) {
      message.error('File upload failed.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <Modal
      open={true}
      onCancel={hide}
      title="Upload Vols"
      footer={null}
      width={600}
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        {/* File input for CSV files */}
        <input type="file" accept=".csv" onChange={handleFileChange} />
        <Button
          type="primary"
          onClick={handleUpload}
          loading={uploading}
          disabled={!file}
        >
          Upload
        </Button>
      </Space>
    </Modal>
  );
};

export default UploadVolsModal;
